import { useEffect, useState } from "react";
import { GetCompanyById } from "../../services/CompanyService";
import { GetNoticeById } from "../../services/NoticeService";
import {
  InsertRowAboveOutlined,
  SettingOutlined,
  SwapOutlined,
  TableOutlined,
} from "@ant-design/icons";
import CustomButton from "../share/customButton";
import { ColorPalette } from "../share/color/colorPalette";
import { Switch } from "antd";

interface MessageProps {
  noticeId: any;
  myCompanyName: string;
  OtherCompanyId: any;
  ShowCompareTableModalState: any;
  ShowAnsweresTableModalState: any;
  GetShowCompareTableVisibleModalState: any;
  SetShowNoticeStateModalState: any;
  SetPriceLogVisiblity: any;
  //messageTypes: number;
}

// Define the Message component
const GroupCardHeader: React.FC<MessageProps> = ({
  noticeId,
  myCompanyName,
  OtherCompanyId,
  ShowCompareTableModalState,
  ShowAnsweresTableModalState,
  GetShowCompareTableVisibleModalState,
  SetShowNoticeStateModalState,
  SetPriceLogVisiblity,
}) => {
  const [noticeTitle, setNoticeTitle] = useState(null);
  const [otherCompany, setOtherCompany] = useState(null);

  async function GetNoticeByIdAsync(id: any) {
    return await GetNoticeById(id);
  }
  async function GetCompanyByIdAsync() {
    await GetCompanyById(OtherCompanyId).then((p) =>
      setOtherCompany(p?.data?.data?.name)
    );
  }
  useEffect(() => {
    GetCompanyByIdAsync();
  }, [OtherCompanyId]);
  useEffect(() => {
    GetNoticeByIdAsync(noticeId).then((p) => setNoticeTitle(p.data.title));
  }, [noticeId]);
  useEffect(() => {
    GetNoticeByIdAsync(noticeId).then((p) => setNoticeTitle(p.data.title));
    GetCompanyByIdAsync();
  }, []);

  return (
    <div className="clo-12" style={{ backgroundColor: "transparent" }}>
      <div className="" style={{ display: "inline-block" }}>
        {noticeTitle} - ({myCompanyName} - {otherCompany} ){" "}
      </div>
      <div
        style={{
          display:
            GetShowCompareTableVisibleModalState === true
              ? "inline-block"
              : "none",
        }}
        className="mx-2"
      >
        <TableOutlined
          onClick={() => ShowCompareTableModalState(true)}
          rev={undefined}
        />
      </div>
      <div
        style={{
          display:
            GetShowCompareTableVisibleModalState === true ? "none" : "none",
        }}
        className="mx-2"
      >
        <SwapOutlined
          onClick={() => SetShowNoticeStateModalState(true)}
          rev={undefined}
        />
      </div>

      <div
        style={{
          display:
            GetShowCompareTableVisibleModalState === false
              ? "inline-block"
              : "none",
        }}
        className="mx-2"
      >
        <CustomButton
          onClick={() => ShowAnsweresTableModalState(true)}
          icon={<InsertRowAboveOutlined />}
          customSize="Large"
          type="primary"
          hasTitle={true}
          style={{ width: "100%" }}
        >
          جدول قیمت گذاری
        </CustomButton>
      </div>

      <SettingOutlined
        style={{ float: "left" }}
        // onClick={() => ShowAnsweresTableModalState(true)}
        rev={undefined}
      />
      <Switch
        style={{ float: "left", marginLeft: "10px" }}
        defaultValue={false}
        onChange={(p) => SetPriceLogVisiblity(p)}
      />
      <span style={{ float: "left", marginLeft: "10px" }}>پیغام های سیستم</span>
    </div>
  );
};
export default GroupCardHeader;
